import Vue from 'vue'
import {adminRoles, UserRoleEnum} from '@/enums/userRolesEnum'
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import { globalObject } from '@/utils/proxyDataUtil'
import { ViewStateType } from '@/enums/ViewStateType';

export default Vue.extend({
  name: 'Facilities',
  data () {
    return {
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      processing: false,
      searchInput: '',
      searchCountResults: 0,
      allowForceResultsMaximum: 500,
      allowForceResults: false,
      loadingSearchResults: false,
      searchResults: [],
      performSearchTimeout: null as any
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  computed: {
    isFacilityUser(): boolean {
      return this.$store.state.user.isFacility;
    }
  },
  created () {
    if (this.isFacilityUser) {
      this.searchFacilities();
    }
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole']([... adminRoles, UserRoleEnum.FACILITY_CONTACT ]);
  },
  mounted: function () {
    // This timeout needs to occur because of the "transition" effect on making the dropdown appear visible from "visibility:hidden".
    // The transition is 300 milliseconds, so this timeout set to greater than about 100ms to allow time for the input element to
    // become visible before focusing.
    if (!this.isFacilityUser) {
      setTimeout(() => {
        (this.$refs.facilitySearch as any).focus();
        (this.$refs.facilitySearch as any).select();
      }, 300);
    }
    
    this.searchInput = this.$store.state.viewState[ViewStateType.FACILITY_SEARCH_SIMPLE] ? this.$store.state.viewState[ViewStateType.FACILITY_SEARCH_SIMPLE] : '';
    if (this.searchInput && this.searchInput.length) { this.searchFacilities(); }
  },
  filters: {
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    address2 (address2: string ) {
      if (address2 && address2.length) {
        return ', ' + address2;
      }
      return '';
    },
    paysMileage (paysMileage: boolean ) {
      return paysMileage ? 'Yes' : 'No';
    },
    fee (fee: any ) {
      if (fee) {
        return ' $' + fee;
      }
      return '$0';
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    state (state: string) {
      if (state && state.length) {
        return ', ' + state;
      }
      return '';
    }
  },
  methods: {
    searchFacilities (force: boolean = false) {
      let self = this;
      let forceResults = force;
      if (this.processing) { return; }
      this.processing = true;
      this.performSearchTimeout = setTimeout(function () {
        let showLoadingSpinnerTimeout = setTimeout(function () {
          self.loadingSearchResults = true;
        }, 0);
        let currentSearchInput = self.searchInput;
        self.$store.dispatch('viewState/updateViewState', {name: ViewStateType.FACILITY_SEARCH_SIMPLE, value: currentSearchInput});

        HTTP.get('/api/facilities/search?facilityNameLike=' + currentSearchInput + '&forceResults=' + forceResults)
        .then(function (response) {
          self.processing = false;
          // If the response is a count, display the count message
          // If the response is a list, display the list

          // If the search results results are empty, display the count
          // If the count is greater than 0 display the count at the option to force retriving the results
          //  as long as the results are less than 150

          let queryCountResults = response.data.data.count;

          self.searchCountResults = queryCountResults;
          self.searchResults = response.data.data.results;
          self.allowForceResults = queryCountResults < self.allowForceResultsMaximum;

          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingSearchResults = false;

          if (self.searchInput !== currentSearchInput) {
            self.searchFacilities(force);
          }
        })
        .catch(() => {
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingSearchResults = false;

          self.processing = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Getting Results',
            text: 'Something went wrong getting search results!',
          });
        })
      }, 250);
    },
    selectFacility (facility: any) {
      // We are using this "globalObject" as a temporary holder of the facility
      // object so we can display the facility's name right away on the next page
      // to avoid the network delay making us show a blank name for a view milliseconds.
      globalObject.variable1 = facility;
      this.$router.push({name: 'Facility', params: {facilityId: facility.id}});
    },
    addNewFacility () {
      console.log('addNewFacility');
      this.$router.push({name: 'NewFacility'});
    },
    onCopy (param: any) {
      console.log('Copied!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
        // duration: 5000
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
        // duration: 5000
      });
    },
    goToAdvancedSearch () {
      this.$router.push({name: 'FacilitiesAdvancedSearch'});
    },

  }
})



// WEBPACK FOOTER //
// ./src/components/facilities/Facilities.ts